import { Component, OnInit } from '@angular/core';
import { DialogConfig, DialogConfigData } from '@app/common/models/dialog-config';
import { DialogRef } from '@app/common/services/dialog-ref';
import { AttachmentTypeModel } from '../../models/attachment-type.model';

@Component({
  selector: 'attachment-choose-type-only-form',
  templateUrl: './attachment-choose-type-only-form.component.html',
})
export class AttachmentChooseTypeOnlyFormComponent implements OnInit {

  attachmentTypes: AttachmentTypeModel[];
  selectedAttachmentType: AttachmentTypeModel;

  constructor(
    private dialogConfig: DialogConfig,
    public dialogComponent: DialogRef,
  ) {
    this.onSave = this.onSave.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.isValid = this.isValid.bind(this);
  }

  ngOnInit() {
    const data = this.dialogConfig.data as DialogConfigData;
    this.attachmentTypes = JSON.parse(JSON.stringify(data.attachmentTypes));

    // check disabled types
    for (const disabledAttachmentType of data.disabledAttachmentTypes) {
      const found = this.attachmentTypes.find(dt => dt.id === disabledAttachmentType.attachmentType);
      if (found) {
        found.disabled = disabledAttachmentType.reason;
      }
    }

    if (this.attachmentTypes.length === 1 && !this.attachmentTypes[0].disabled) {
      this.dialogComponent.close(this.attachmentTypes[0]);
    }
  }

  onUpdateType(attachmentType: AttachmentTypeModel) {
    this.selectedAttachmentType = attachmentType;
  }

  isValid() {
    return this.selectedAttachmentType;
  }

  onSave() {
    this.dialogComponent.close(this.selectedAttachmentType);
  }

  onCancel() {
    this.dialogComponent.close(false);
  }
}
